import { LenderMap, LenderName } from '@nemuru-eng/js-api-client';

export const ALL_LENDERS = Object.values(LenderName)
  .map((name) => ({
    name,
    id: LenderMap.fromLenderName(name) as string,
  }))
  .sort((a, b) => a.name.localeCompare(b.name));
